<template>
    <div>
        <b-modal
            id="cageCardModal"
            ref="cageCardModal"
            :lazy="true"
            title-tag="h2"
            title="Select Printer"
        >
            <!-- Modal Form -->
            <b-form-group
                :label-for="`printer`"
                label="Printer:"
                label-cols="3"
            >
                <b-form-select
                    id="printer"
                    :v-validate="'required'"
                    :options="printers"
                    v-model="printer_data.printer"
                    class="form-control"
                    value-field="id"
                    text-field="name"
                >
                    <template>
                        <!-- <option :value="null" disabled>Please select a printer (required)</option> -->
                        <!-- <option value="local">Generate PDF</option> -->
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group
                :label-for="`quantity`"
                label="Quantity:"
                label-cols="3"
            >
                <b-form-input
                    id="quantity"
                    v-model="printer_data.quantity"
                    :v-validate="'required|numeric'"
                    :disabled="
                        printer_data.printer == 'local' ||
                        printer_data.printer == null
                    "
                    placeholder="Quantity (required)"
                    type="number"
                    min="0"
                    step="1"
                ></b-form-input>
            </b-form-group>
            <div slot="modal-footer" class="w-100">
                <b-button
                    @click="$refs.cageCardModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="print" v-else variant="primary"
                        >Print</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
export default {
    mixins: [ScheduleHelper],
    data() {
        return {
            id: null,
            loading: false,
            action: "PRINT_CAGE_CARD",
            printer_data: {
                printer: "local",
                quantity: 1
            },
            printers: [],
            print_data: {}
        };
    },
    computed: {
        isPatientProfile() {
            return this.$route.name == "patient_profile";
        },
        isSoap() {
            return this.$route.name == "soap";
        }
    },
    watch: {
        "printer_data.printer"(data) {
            if (data) {
                if (data == "local" || data == null) {
                    this.printer_data.quantity = 1;
                } else {
                    this.printer_data.printer = data;
                }
            }
        }
    },
    mounted() {
        this.addScript(this.env.APPS + "assets/js/DYMO.Label.Framework.3.0.js");
    },
    methods: {
        open(params) {
            this.print_data = params;
            this.action = params.action && params.action;

            this.$root.$emit("appointment:preview:loading", true);
            if (
                this.isVetterPrintEnabled() ||
                this.isPatientProfile ||
                this.isSoap
            ) {
                this.getPrinters().finally(() =>
                    this.$root.$emit("appointment:preview:loading", false)
                );
                this.$refs.cageCardModal.show();
            } else {
                if (this.print_data.client && this.print_data.patient) {
                    this._printCageCard({
                        client_id: this.print_data.client.id,
                        patient_id: this.print_data.patient.id,
                        printer: "true",
                        print_quantity: this.printer_data.quantity
                    }).finally(() =>
                        this.$root.$emit("appointment:preview:loading", false)
                    );
                } else {
                    this._message(
                        "Appointment doesn't have patient attached",
                        "danger"
                    );
                }
            }
        },
        async getPrinters() {
            let self = this;

            let url = process.env.ACCOUNT_SERVICE + "printer";

            let response = await this.$http.get(url);

            if (response) {
                self.printers = response.data.response.resources;

                if (self.printers) {
                    self.printers.map(printer => {
                        if (printer.is_default == 1) {
                            self.printer_data.printer = printer.id;
                        }
                    });
                }
            }
        },
        isVetterPrintEnabled() {
            return this._isExtensionEnabled("VETTER_PRINTER");
        },
        print() {
            let self = this;
            if (self.action === "PRINT_LABEL") {
                if (this.print_data && this.print_data.record_id) {
                    let params = {
                        record_id: this.print_data.record_id,
                        module_type: this.print_data.record_type,
                        printer: this.printer_data.printer,
                        print_quantity: this.printer_data.print_quantity || this.printer_data.quantity // prettier-ignore
                    };

                    this.loading = true;
                    this._printLabel(params)
                        .then(function () {
                            self.$refs.cageCardModal.hide();
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            } else {
                if (this.print_data && this.print_data.client) {
                    let params = {
                        client_id: this.print_data.client_id,
                        patient_id: this.print_data.patient_id,
                        printer: this.printer_data.printer,
                        print_quantity:
                            this.printer_data.print_quantity ||
                            this.printer_data.quantity
                    };

                    this.loading = true;
                    this._printCageCard(params)
                        .then(function () {
                            self.$refs.cageCardModal.hide();
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        }
    }
};
</script>
